import { Grid, Typography } from "@mui/material";
import { TimePeriodFilterDropdown } from "Components/Shared/Filters/TimePeriodFilterDropdown";
import { Resources, useResource } from "Translations/Resources";
import type { TimePeriod } from "Types/TimePeriod";

const RESOURCES = Resources.Components.Shared.Filters;

type Props = {
  value?: TimePeriod;
  onChange: (value: TimePeriod | undefined) => void;
};

export const TimePeriodFilter = ({ value, onChange }: Props) => {
  const { t } = useResource();

  return (
    <Grid size={{ xs: 12, sm: 6 }}>
      <Typography fontSize={13} fontWeight={400} mb={1}>
        {t(RESOURCES.TimePeriod)}
      </Typography>
      <TimePeriodFilterDropdown value={value} onChange={onChange} />
    </Grid>
  );
};
